import { Alert, AlertColor, AlertProps, SxProps, Theme, Slide } from '@mui/material';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import * as React from 'react';
import type { SlideProps } from '@mui/material/Slide';

export const ToastType: { [key in AlertColor]: AlertColor } = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

export type ToastProps = SnackbarProps & {
  message: string;
  type: AlertProps['severity'];
  onClose?: (event: React.SyntheticEvent | Event, reason?: string) => void;
  anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right' };
  alertStyles?: SxProps<Theme> | undefined;
  slideDirection?: 'up' | 'down' | 'left' | 'right';
};

function SlideTransition(props: SlideProps, direction: 'up' | 'down' | 'left' | 'right' = 'up') {
  return <Slide {...props} direction={direction} />;
}

export default function Toast({
  message,
  type,
  onClose,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  alertStyles = {},
  slideDirection = 'up',
  ...rest
}: ToastProps) {
  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      autoHideDuration={type === 'success' ? 1500 : 5000}
      key={`${message}-${type}`}
      sx={{ width: '40%' }}
      open={rest.open}
      onClose={onClose}
      TransitionComponent={(props) => SlideTransition(props, slideDirection)}
      {...rest}
    >
      <Alert onClose={onClose} severity={type} sx={alertStyles}>
        {message}
      </Alert>
    </Snackbar>
  );
}
